import { render, staticRenderFns } from "./CMMembersGroupDetail.vue?vue&type=template&id=3ee926d4&"
import script from "./CMMembersGroupDetail.vue?vue&type=script&lang=js&"
export * from "./CMMembersGroupDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\corpmessengerwebapp_rtp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ee926d4')) {
      api.createRecord('3ee926d4', component.options)
    } else {
      api.reload('3ee926d4', component.options)
    }
    module.hot.accept("./CMMembersGroupDetail.vue?vue&type=template&id=3ee926d4&", function () {
      api.rerender('3ee926d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/accounts/CMMembersGroupDetail.vue"
export default component.exports